export interface IPagination {
  perPage: number;
  page: number;
  total: number;
}
export interface IPaginatedList<T> {
  items: T[];
  pagination: IPagination;
}

export const DEFAULT_PAGE_SIZE = 1000;
